import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TrialExpiredDialogComponent } from './trial-expired-dialog.component';

@NgModule({
  declarations: [TrialExpiredDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [TrialExpiredDialogComponent],
  entryComponents: [TrialExpiredDialogComponent],
})
export class TrialExpiredDialogModule {}
